export const exportLeadsToCsv = (leads = [], filename = 'leads.csv') => {
  if (!Array.isArray(leads) || leads.length === 0) return;

  const headers = [
    'Name',
    'Designation',
    'Company',
    'City',
    'State',
    'Email',
    'Phone',
    'LinkedIn',
    'AI Score',
  ];

  const formatListValue = (value) =>
    Array.isArray(value) ? value.join('; ') : '';
  const formatCellValue = (value) =>
    value === null || value === undefined ? '' : value;

  const rows = leads.map((lead) => [
    lead.name || '',
    lead.designation || '',
    lead.company || '',
    lead.city || '',
    lead.state || '',
    formatListValue(lead.emails),
    formatListValue(lead.phones),
    formatListValue(lead.linkedin),
    lead.ai_score ?? '',
  ]);

  const csvContent = [headers, ...rows]
    .map((row) =>
      row
        .map((cell) => `"${String(formatCellValue(cell)).replace(/"/g, '""')}"`)
        .join(',')
    )
    .join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  window.URL.revokeObjectURL(url);
};
